/** Why an operator closes a period early (mirrors `@vello/business-billing` `PARTNER_EARLY_CLOSE_REASONS`). */
export const PARTNER_EARLY_CLOSE_REASONS = ['PARTNER_REQUEST', 'CREDIT_REVIEW', 'ACCOUNT_OFFBOARDING', 'BILLING_CORRECTION'];
/** Why a checker rejects a pending payment (mirrors `PARTNER_PAYMENT_REJECT_REASONS`). */
export const PARTNER_PAYMENT_REJECT_REASONS = ['PAYMENT_NOT_RECEIVED', 'REFERENCE_MISMATCH', 'DUPLICATE_ENTRY', 'AMOUNT_DISPUTED'];
/** Why a partner is credited (mirrors `@vello/business-billing` `PARTNER_CREDIT_NOTE_REASONS`). */
export const PARTNER_CREDIT_NOTE_REASONS = ['SERVICE_FAILURE', 'BILLING_CORRECTION', 'GOODWILL', 'DISPUTE_SETTLEMENT'];
export class PartnerBillingAdminApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** Every partner account with its open exposure, its open statement and how many payments await approval. */
    accounts() {
        return this.client.request({ method: 'GET', path: '/v1/admin/partner-accounts', auth: true });
    }
    /** An account's statements, newest period first. */
    statements(accountId) {
        return this.client.request({ method: 'GET', path: `/v1/admin/partner-accounts/${encodeURIComponent(accountId)}/statements`, auth: true });
    }
    /** One statement: its lines by vertical, totals and payments. */
    statement(statementId) {
        return this.client.request({ method: 'GET', path: `/v1/admin/partner-statements/${encodeURIComponent(statementId)}`, auth: true });
    }
    /** Close the account's open period now (201), or replay a close with the same key (200, `replayed: true`). */
    closePeriod(accountId, input) {
        return this.client.request({ method: 'POST', path: `/v1/admin/partner-accounts/${encodeURIComponent(accountId)}/statements/close`, body: input, auth: true });
    }
    /** MAKER: record the payment of a CLOSED statement. It waits for a different operator's approval. */
    recordPayment(statementId, input) {
        return this.client.request({ method: 'POST', path: `/v1/admin/partner-statements/${encodeURIComponent(statementId)}/payments`, body: input, auth: true });
    }
    /**
     * MAKER (D398): a credit note on a CLOSED statement. 201 = issued at once (at or below the governed threshold, within
     * the maker's grant); 202 = waiting in the refund queue for a different operator. Refusals: `STATEMENT_OPEN`,
     * `STATEMENT_ALREADY_PAID`, `CREDIT_CURRENCY_MISMATCH`, `CREDIT_MARKET_REQUIRED`, `CREDIT_MARKET_NOT_ON_STATEMENT`,
     * `CREDIT_EXCEEDS_MARKET_SUBTOTAL`, `CREDIT_EXCEEDS_AMOUNT_DUE`, `PAYMENT_ALREADY_PENDING` (409),
     * `CREDIT_AMOUNT_INVALID`, `CREDIT_REASON_INVALID` (400), `FINANCIAL_LIMIT_EXCEEDED` (403).
     */
    issueCreditNote(statementId, input) {
        return this.client.request({ method: 'POST', path: `/v1/admin/partner-statements/${encodeURIComponent(statementId)}/credit-notes`, body: { ...input }, auth: true });
    }
    /** The payments queue (pending approval by default). */
    payments(status = 'PENDING_APPROVAL') {
        return this.client.request({ method: 'GET', path: `/v1/admin/partner-statement-payments?status=${encodeURIComponent(status)}`, auth: true });
    }
    /** CHECKER: approve — the statement becomes PAID and the account's limit is released. The maker is refused (403 SELF_APPROVAL). */
    approvePayment(paymentId) {
        return this.client.request({ method: 'POST', path: `/v1/admin/partner-statement-payments/${encodeURIComponent(paymentId)}/approve`, body: {}, auth: true });
    }
    /** CHECKER: reject a pending payment with a reason code; the statement stays CLOSED. */
    rejectPayment(paymentId, reasonCode) {
        return this.client.request({ method: 'POST', path: `/v1/admin/partner-statement-payments/${encodeURIComponent(paymentId)}/reject`, body: { reasonCode }, auth: true });
    }
}
//# sourceMappingURL=partner-billing.js.map